module.exports = __webpack_public_path__ + "img/section4_2.4191a6a9.png";